import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";
import { extraTranslations } from "@/i18n/extra";

const LanguageContext = createContext(null);

function mergeTranslations() {
  const merged = {};
  for (const lang of Object.keys(translations)) {
    const base = translations[lang];
    const extra = extraTranslations[lang] || {};
    merged[lang] = {
      ...base,
      framework: { ...base.framework, ...(extra.framework || {}) },
      assessment: { ...base.assessment, ...(extra.assessment || {}),
                    opts: { ...(base.assessment?.opts || {}), ...((extra.assessment && extra.assessment.opts_extra) || {}) } },
      mediation: { ...base.mediation, ...(extra.mediation || {}) },
      privacy: extra.privacy || {},
      agreement: extra.agreement || {},
      consent: extra.consent || {},
      nav: { ...base.nav, privacy: extra.nav_privacy, agreement: extra.nav_agreement },
      footer: { ...base.footer, privacy: extra.footer?.privacy },
    };
  }
  return merged;
}

const MERGED = mergeTranslations();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mift_lang") || "en");
  useEffect(() => {
    localStorage.setItem("mift_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = MERGED[lang] || MERGED.en;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang outside provider");
  return ctx;
}

export function ensureSessionId() {
  let sid = localStorage.getItem("mift_sid");
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem("mift_sid", sid);
  }
  return sid;
}
